export default [
  {
    path: '/demo/appShare',
    component: () => import('@/views/demo/AppShare.vue'),
    name: 'demo-appShare',
    meta: {
      auth: 0,
      title: '分享调试',
      backgroundClass: 'bg-gray',
    },
  },
];
